import type { SelfServiceData } from '../types';

const hasContactDetails = (data: SelfServiceData): boolean => {
  return !!(data.contactName?.trim() && data.contactMobil?.trim() && data.contactEmail?.trim());
};

export const requireContactInfo = (data: SelfServiceData): string | null => {
  return hasContactDetails(data) ? null : 'Udfyld venligst dine kontaktoplysninger.';
};

export const requireTimeSelection = (data: SelfServiceData): string | null => {
  return data.location && data.date && data.time ? null : 'Vælg venligst en tid.';
};
